export const COOKIE_MESSAGE = '<p class="content is-medium">Utilizamos cookies propias y de terceros para ofrecer ' +
    'nuestros servicios, recoger informaciÃ³n estadÃ­stica e incluir publicidad. Si continÃºa navegando, acepta su ' +
    'instalaciÃ³n y uso. Puede obtener mÃ¡s informaciÃ³n en nuestra.<br>' +
    '<a class="button is-black cookie-accept">Aceptar</a></p>';
